import React from 'react';
import { useTranslation } from 'react-i18next';

// styles
import * as Styled from 'eCoach/_styles/ConvoPrep.style';
import * as Text from 'theme/components/Text.style';

interface ConversationItem {
  description?: string;
  prep?: string[];
  reactions?: string[];
  example_language?: string[];
  [key: string]: any;
}

interface ConversationItemDetailsProps {
  item: ConversationItem;
  title?: string;
}

export default function ConversationItemDetails({
  item,
}: ConversationItemDetailsProps): JSX.Element {
  const { t } = useTranslation('pageEcoach');

  if (!item) return <></>;

  return (
    <Styled.Content>
      <Text.P2 style={{ marginBottom: '15px' }}>{item?.description}</Text.P2>

      <div>
        <Text.P2Semibold>
          {t('convoPrep.ConversationItemDetails.Checklist')}
        </Text.P2Semibold>
        <Styled.List style={{ listStyleType: 'none', paddingInlineStart: '0' }}>
          {item?.prep?.map((pro) => (
            <li
              key={pro}
              style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}
            >
              <input type="checkbox" style={{ marginTop: '2px' }} />
              {pro}
            </li>
          ))}
        </Styled.List>
      </div>

      <div>
        <Text.P2Semibold>
          {t(
            'convoPrep.ConversationItemDetails.Anticipating and handling reactions'
          )}
        </Text.P2Semibold>
        <Styled.List>
          {item?.reactions?.map((con) => (
            <li key={con}>{con}</li>
          ))}
        </Styled.List>
      </div>

      <div>
        <Text.P2Semibold>
          {t('convoPrep.ConversationItemDetails.Example dialogue')}
        </Text.P2Semibold>
        <Styled.List>
          {item?.example_language?.map((con) => (
            <li key={con}>{con}</li>
          ))}
        </Styled.List>
      </div>
    </Styled.Content>
  );
}
